import type { ConfigApi } from '@backstage/core-plugin-api';

// Shared by the dashboard, Request Profile page, and entity cards — the
// reconciliation poll fallback's cadence, config-driven per config.d.ts
// rather than a hardcoded literal in each consumer. Each call site keeps
// its own default: the dashboard/entity cards (currently zero polling)
// default to 60s, while RequestProfilePage's existing per-request poll
// keeps its today's-behavior 4s default — a shared 60s default would have
// silently slowed that page down 15x for anyone not setting the config.
export function getPollIntervalMs(
  config: ConfigApi,
  key: string,
  defaultMs: number,
): number {
  return config.getOptionalNumber(key) ?? defaultMs;
}
